import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  return authorizedResources.reduce<AuthorizedResourceAccessMap>(
    (accumulator, resource) => {
      if (!resource?.code) {
        return accumulator;
      }

      const allowed = isAuthorizedResourceAllowed(resource.effect);

      accumulator[resource.code] = allowed;

      const actions = resource.actions ?? [];
      actions.forEach((action) => {
        if (action) {
          accumulator[`${resource.code}:${action}`] = allowed;
        }
      });

      if (!actions.length || actions.includes('manage')) {
        ['view', 'edit', 'manage', 'approve'].forEach((action) => {
          accumulator[`${resource.code}:${action}`] = allowed;
        });
      }

      return accumulator;
    },
    {},
  );
}
